import { Component } from "react";
import OCPList from "./OCPList";

class ChallanList extends Component {
  render() {
    return <OCPList module="Challan" entryPage="ChallanEntry" />;
  }
}

export default ChallanList;
